import {ChevronRightIcon, ShoppingCartIcon} from '@heroicons/react/20/solid';
import React from "react";

export default function CheckoutNavigationSteps() {
    const currentPath = window.location.pathname;

    return (
        <div className="border-b border-dotted border-black overflow-x-auto">
            <ol
                role="list"
                className="flex flex-row justify-center sm:justify-start items-center gap-2 sm:gap-4 p-4 w-full"
            >
                {/* Cart */}
                <li className="flex items-center">
                    <a href="/cart" className="flex items-center text-sm">
                        <ShoppingCartIcon
                            className={`h-5 w-5 ${
                                currentPath === "/cart" ? "text-green-600" : "text-gray-400"
                            }`}
                        />
                    </a>
                </li>

                <li className="flex items-center">
                    <a href="/cart" className="flex items-center text-sm">
                        <span
                            className={`text-sm ${
                                currentPath === "/cart" ? "text-green-600 font-bold" : "text-gray-500 font-medium"
                            }`}
                        >
              Cart
            </span>
                    </a>

                </li>

                {/* Chevron */}
                <li>
                    <ChevronRightIcon className="w-5 h-5 text-gray-400"/>
                </li>

                {/* Checkout */}
                <li className="flex items-center">
                    <a
                        href="/checkout"
                        className={`text-sm ${
                            currentPath === "/checkout"
                                ? "text-green-600 font-bold"
                                : "text-gray-500 hover:text-gray-700 font-medium"
                        }`}
                        aria-current={currentPath === "/checkout" ? "page" : undefined}
                    >
                        Checkout
                    </a>
                </li>

                {/* Chevron */}
                <li>
                    <ChevronRightIcon className="w-5 h-5 text-gray-400"/>
                </li>

                {/* Payment */}
                <li className="flex items-center">
                    <a
                        href="/payment"
                        className={`text-sm ${
                            currentPath === "/payment"
                                ? "text-green-600 font-bold"
                                : "text-gray-500 hover:text-gray-700 font-medium"
                        }`}
                        aria-current={currentPath === "/payment" ? "page" : undefined}
                    >
                        Payment
                    </a>
                </li>
            </ol>
        </div>
    );
}
